import * as angular from 'angular';
import { ILocationService, ui } from 'angular';
import * as _ from 'lodash';
import { Cohort } from '../../../../../ng2/shared/constants/cohort.constant';

export class GradPlanningMetricsCtrl {
  static $inject = ['$scope', '$state', '$location', 'SDCStore', 'SpinnerModal'];

  private currentSchool: any;

  constructor(
    private $scope,
    private $state: ui.IStateService,
    private $location: ILocationService,
    private SDCStore: any,
    private SpinnerModal: any,
  ) {
    this.SpinnerModal.deactivateSpinner();
  }

  public checkUnsavedChanges;
  public selectedCohort;
  public cohort;

  $onInit(): void {
    this.updateSelectedCohort();
    this.currentSchool.trackServerState();
  }

  updateSelectedCohort() {
    const url = this.$location.url();
    if (_.includes(url, 'fourth-year-students')) {
      this.selectedCohort = 0;
      let result = _.filter(Cohort, { studentYear: 4 });
      this.cohort = result[0];
    } else if (_.includes(url, 'third-year-students')) {
      this.selectedCohort = 1;
      let result = _.filter(Cohort, { studentYear: 3 });
      this.cohort = result[0];
    } else if (_.includes(url, 'second-year-students')) {
      this.selectedCohort = 2;
      let result = _.filter(Cohort, { studentYear: 2 });
      this.cohort = result[0];
    } else if (_.includes(url, 'first-year-students')) {
      this.selectedCohort = 3;
      let result = _.filter(Cohort, { studentYear: 1 });
      this.cohort = result[0];
    }
    if (!this.cohort) {
      this.selectedCohort = 0;
      let result = _.filter(Cohort, { studentYear: 4 });
      this.cohort = result[0];
    }
  }
}

angular.module('nv.SchoolMetricsModule').controller('GradPlanningMetricsCtrl', GradPlanningMetricsCtrl);
